function trim(str) {
  var trimmed = str ? str.trim() : undefined;
  if (!trimmed || trimmed.length === 0) {
    return undefined;
  }
  return trimmed;
}

export { trim };
//# sourceMappingURL=trim.esm.js.map
